import { fetchConstants } from '../_constants';

export const fetchActions = {
    start,
    error,
    success,
    abort,
};

function start() {
    return { type: fetchConstants.START };
}

function error() {
    return { type: fetchConstants.ERROR };
}

function success() {
   return { type: fetchConstants.SUCCESS };
}

function abort(all) {
    return { type: fetchConstants.ABORT, payload: { all: !!all } };
}